import { render, staticRenderFns } from "./a_covid.vue?vue&type=template&id=3afde82f&scoped=true"
import script from "./a_covid.vue?vue&type=script&lang=js"
export * from "./a_covid.vue?vue&type=script&lang=js"
import style0 from "./a_covid.vue?vue&type=style&index=0&id=3afde82f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afde82f",
  null
  
)

export default component.exports